import type { CollapseProps } from "antd";
import { panelStyle } from "./style";

import Info from "./Info";
import BannerDetail from "./BannerMobileDetail";
import BannerMobileFiles from "./BannerMobileFiles";


export const BannerDetailConstants = {
	EN: "Banner Details",
	TR: "Banner Detayları"
};

export const BannerConstants = {
	INFO: "Banner Resimleri",
	BANNER_DETAIL: BannerDetailConstants,
	BANNER_FILES: "Banner Dosyaları",
};

export const BannerMobileItems: CollapseProps["items"] = [
	{
		key: "1",
		label: BannerConstants.INFO,
		children: <Info />,
		style: panelStyle,
	},
	{
		key: "2",
		label: BannerConstants.BANNER_FILES,
		children: <BannerMobileFiles />,
		style: panelStyle,
	},
	{
		key: "3",
		label: BannerConstants.BANNER_DETAIL.TR,
		children: <BannerDetail Culture="tr-TR" />,
		style: panelStyle,
	},
	{
		key: "4",
		label: BannerConstants.BANNER_DETAIL.EN,
		children: <BannerDetail Culture="en-US" />,
		style: panelStyle,
	},
];
